$('.roots-column').mouseover(function(e){
    var parent = $(this).closest('.container-roots');
    var thisID = $(this).attr('id');

    parent.find('.roots-column').each(function(){
        if( $(this).attr('id') !== thisID ) {
            $(this).removeClass('active');
            $(this).addClass('inactive');
        }
    });
    if( !$(this).hasClass('active') ) {
        $(this).addClass('active');
    }
});

$('.roots-column').mouseout(function(e){
    if( $(window).innerWidth() >= 768 ) {
        if( $(this).hasClass('active') ) {
            $(this).removeClass('active');
            $(this).removeClass('inactive');
        }
    }
});

$('.content-wrapper').click(function(e){
    if( $(window).innerWidth() >= 768 ) {
        var headingText = $(this).find('.font-heading').html();
        var subheadingText = $(this).find('.font-subheading').html();
        var paragraphText = $(this).find('.font-paragraph').html();
        var lightbox = $(this).parent().parent().parent().find('.container-lightbox');
        var background = $(this).parent().css('background-image');

        lightbox.find('.font-heading').html(headingText);
        lightbox.find('.font-subheading').html(subheadingText);
        lightbox.find('.font-paragraph').html(paragraphText);

        lightbox.addClass('active');
        lightbox.css({'background-image' : background });
        lightbox.animate({ opacity : 1 }, 300);
    }
});

$('.lightbox-close').click(function(e){
    if( $(window).innerWidth() >= 768 ) {
        var lightbox = $(this).parent();
        lightbox.animate({ opacity : 0 }, 300);

        setTimeout(function(){
            lightbox.css({'background-image' : 'none' });
            lightbox.removeClass('active');
        }, 301);
    }
})

$( window ).keyup(function(e) {

    if( e.which == 27 ) {
        $('.container-lightbox').each(function(){
            if( $(this).hasClass('active') ) {
                $(this).animate({'opacity' : 0}, 300);

                var _this = $(this);
                setTimeout(function(){
                    _this.removeClass('active');
                    _this.css({'background-image' : 'none' });
                }, 301);
            }
        })
    }
});
